import React, { useContext, useEffect, useState } from "react";
import {} from "./styled";
import DashboardCardTabs from "components/Dashboard/Cards/Tabs";
import DashboardCardTable from "components/Dashboard/Cards/Table";
import { useHistory, useLocation } from "react-router-dom";
import { CoreContext } from "context/CoreContext";
import { Read, ReadById, Delete } from "services/vacations";
import { exposeStrapiError, normalizeStrapiList } from "utils";
import DashboardActions from "components/Dashboard/Actions";
import moment from "moment";
import { toast } from "react-toastify";

export default function DashboardListsVacantion() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);

  const [activeTab, setActiveTab] = useState(0);
  const { searchExpression, currentCompany, user } = useContext(CoreContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [registers, setRegisters] = useState([]);

  // const actions = [
  //   ...(user?.isManager
  //     ? [{ title: "Novo", action: () => navigate("dashboard/vacantion/add") }]
  //     : []),
  // ];

  const actionsSingle = [
    {
      title: "Download",
      action: (id) => downloadById(id),
      loadable: true,
    },
  ];

  if (user?.isManager) {
    actionsSingle.push({
      title: "Excluir",
      action: (id) => deleteSingleVacation(id),
      loadable: true,
    });
  }

  const columns = [
    { title: "Inicio Período Aquisitivo", ref: "initialDate" },
    { title: "Final Período Aquisitivo", ref: "endDate" },
    { title: "CPF", ref: "cpf" },
    { title: "Nome do funcionário", ref: "name" },
    { title: "Data e hora da criação", ref: "createDate" },
    // { title: "Usuário que importou", ref: "importingUser" },
    {
      title: "",
      ref: "",

      renderCell: (row) => (
        <DashboardActions
          actions={renderCellActions(row)}
          loading={row.loading}
          onClick={(e) => e.stopPropagation()}
        />
      ),
    },
  ];

  const renderCellActions = (row) => {
    return actionsSingle.map((action) => ({
      ...action,
      action: () => action.action(row.row.id),
    }));
  };

  // ajustes nos campos da lista se necessário
  const parseRegister = (item) => ({
    ...item,
    cpf: formatCPF(item?.cpf || ""),
    name: item.name,
    createDate: moment(item.createdAt).format("DD/MM/YYYY HH:mm"),
    initialDate: moment(item.initialDate).format("DD/MM/YYYY"),
    endDate: moment(item.endDate).format("DD/MM/YYYY"),
  });

  // formata o cpf
  const formatCPF = (cpf) => {
    return cpf
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  };

  // download do arquivo de férias
  const downloadById = async (id) => {
    setLoading(true);
    try {
      const result = await ReadById(id); // Busca dados pelo Id
      console.log(result.data); // Log para verificar o retorno completo

      // Acessa diretamente os campos dentro de attributes
      const keyUrl = result.data[0]?.attributes?.keyUrl;
      const uploadId = result.data[0]?.attributes?.uploadId;

      if (keyUrl) {
        // Verifica se o keyUrl existe e é válido
        const downloadUrl = keyUrl; // Usa diretamente o link encontrado
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", `recibo_ferias_${uploadId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        toast.error("Nenhum link válido encontrado para download."); // Mensagem de erro caso keyUrl seja indefinido
      }
    } catch (error) {
      console.error("Erro ao baixar os registros:", error);
      toast.error("Erro ao realizar o download: " + error.message);
    } finally {
      init();
      setLoading(false);
    }
  };

  // excluir arquivo de férias
  const deleteSingleVacation = async (id) => {
    setLoading(true);
    try {
      // exclui o registro do banco
      await Delete(id);

      toast.success("Arquivo de férias excluído com sucesso!");

      setRegisters((prevRegisters) =>
        prevRegisters.filter((register) => register.id !== id)
      );
    } catch (error) {
      console.error(error);
      toast.error("Erro ao tentar excluir o arquivo de férias.");
    } finally {
      init();
      setLoading(false);
    }
  };

  const init = async () => {
    setLoading(true);
    try {
      const result = await Read(currentCompany?.id);
      if (result && !exposeStrapiError(result)) {
        const normalRegister = normalizeStrapiList(result) || [];
        setRows(
          normalRegister
            ?.filter((f) => user?.isManager || f?.cpf === user?.cpf)
            ?.map(parseRegister)
        );
      }
    } catch (error) {
      console.error("Erro ao carregar os registros:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentCompany?.id) {
      init();
    }
  }, [currentCompany]);

  return (
    <>
      <DashboardCardTabs
        title={"Férias"}
        // actions={actions}
        active={activeTab}
        setActive={setActiveTab}
      >
        <DashboardCardTable
          rows={rows}
          columns={columns}
          searchExpression={searchExpression}
          pagination
          loading={loading}
        />
      </DashboardCardTabs>
    </>
  );
}
